export default "<body>\n    <div class=\"container-glass\">\n\n\n\n    </div>\n</body>\n";